import { StrictMode, useState, useEffect } from "react"
import { createRoot } from "react-dom/client"
import "@fontsource-variable/outfit"
import "@fontsource-variable/jetbrains-mono"
import App from "./App.jsx"
import GoldenPage from "./GoldenPage.jsx"
import { IS_WEB } from "./utils.js"

const GOLDEN_ROUTING = __DEBUG__ && IS_WEB

function Router() {
  const [isGolden, setIsGolden] = useState(() => GOLDEN_ROUTING && window.location.hash === "#/golden")
  useEffect(() => {
    if (!GOLDEN_ROUTING) return
    const update = () => setIsGolden(window.location.hash === "#/golden")
    window.addEventListener("hashchange", update)
    return () => window.removeEventListener("hashchange", update)
  }, [])

  if (GOLDEN_ROUTING && isGolden) return <GoldenPage />
  if (IS_WEB) {
    window.location.replace("/welcome.html")
    return null
  }
  return <App />
}

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Router />
  </StrictMode>
)
